import React, { useContext } from 'react'
import { Link } from 'gatsby'
import styled from '@emotion/styled'
import tw from 'twin.macro'
import { StoreContext } from '../contexts/ShopifyStoreContext'
import CartIndicator from './Cart/CartIndicator'
import ShoppingBagIcon from '../assets/shopping-bag.svg'
import Bars from '../assets/bars.svg'
import ShoppingBagIconFilled from '../assets/shopping-bag-filled.svg'
import Logo from '../assets/colekt-logo-black.svg'
import { breakpoints } from '../utils/styles'
import {
  GlobalDispatchContext,
  GlobalStateContext,
} from '../contexts/GlobalContextProvider'

const OpenDrawerButton = styled.button`
  ${tw`flex align-middle p-6 uppercase text-lg tracking-wider font-extended z-40 fixed top-0 focus:outline-none`}
  @media (min-width: ${breakpoints.lg}px) {
    right: 17rem;
  }
  @media (min-width: ${breakpoints.xl}px) {
    right: 24.8rem;
  }

  svg {
    height: 1rem;
    width: 0.85rem;
    margin-top: 0.15rem;
    margin-right: 0.5rem;
  }
`
const CartButton = styled.button`
  ${tw`flex align-middle p-6 uppercase text-lg tracking-wider font-extended z-50 fixed top-0 right-0 focus:outline-none`}
  svg {
    height: 1rem;
    width: 1rem;
    margin-right: 0.25rem;
  }
`

const LogoWrap = styled.div`
  ${tw`fixed top-0 z-40 p-0`}
  margin-top: 0px;
  left: 50%;
  transform: translateX(-50%);
  @media (min-width: ${breakpoints.lg}px) {
    padding: 0;
    top: 2.5vw;
    left: 2.5vw;
    transform: translateX(0%);
    margin-left: 0px;
  }
  svg {
    @media (min-width: ${breakpoints.md}px) {
      height: 6vw;
    }
    @media (min-width: ${breakpoints.lg}px) {
      height: 5vw;
    }
  }
`
export default function Header() {
  const dispatch = useContext(GlobalDispatchContext)
  const state = useContext(GlobalStateContext)

  const { cart, cartIsOpen, drawerMenuIsOpen } = state

  const handleLogoClick = () => {
    if (drawerMenuIsOpen) {
      dispatch({ type: 'TOGGLE_DRAWER_MENU' })
    } else if (cartIsOpen) {
      dispatch({ type: 'TOGGLE_CART' })
    }
  }

  const { checkout } = React.useContext(StoreContext)
  const emptyCart = checkout.lineItems.length === 0

  return (
    <div className="whiteonblack">
      <OpenDrawerButton
        type="button"
        onClick={() => {
          dispatch({ type: 'TOGGLE_DRAWER_MENU' })
        }}
      >
        <Bars /> Menu
      </OpenDrawerButton>

      <LogoWrap className="headerlogo">
        <Link to="/" onClick={() => handleLogoClick()}>
          <Logo />
          <span className="sr-only">Colekt</span>
        </Link>
      </LogoWrap>

      <CartButton
        className="whiteonblack"
        onClick={() => {
          dispatch({ type: 'TOGGLE_CART' })
        }}
      >
        {cart ? (
          <>
            {!emptyCart ? <ShoppingBagIconFilled /> : <ShoppingBagIcon />}
            Bag
            {!emptyCart ? <CartIndicator /> : null}
          </>
        ) : null}
      </CartButton>
    </div>
  )
}
